<header>
    <div class="list-count">
        {{ selectedFeatures?.length || ' ' }}
        <loading *ngIf="isLoadingFeatures$ | async" [small]="true"></loading>
    </div>
</header>
<section class="height-full">
    <custom-scroll autoHeightDisable="true">
        <ul>
            <li
                *ngIf="shouldShowAccuracyButton && !shareMapUrl"
                class="accuracy-button"
                [ngClass]="{ selected: isAccuracyPanelDisplayed$ | async }"
                (click)="toggleAccuracyPanel()"
            >
                <i class="accuracy-button-icon i24"></i>
            </li>
            <li
                *ngFor="let feature of selectedFeatures || []; index as i"
                [ngClass]="{
                    selected: activePanelFeature && activePanelFeature.id === feature.id,
                    'select-minus-cur': removeFromSelectionMode,
                    'select-cur': !removeFromSelectionMode
                }"
                (click)="setCurrentFeatureAction(feature)"
            >
                <geom-icon
                    path="symbol_24-preview-"
                    [color]="getFeatureFillColor(feature)"
                    [outlineColor]="getFeatureOutlineColor(feature)"
                    [geoType]="feature.geometryType"
                    [svgIcon]="feature.style.symbol?.svgImage"
                    [symbolType]="feature.style.symbol?.type"
                    [symbolText]="feature.style.symbol?.text"
                    [lineStyle]="feature.style.lineStyle"
                    [polygonOpacity]="feature.style.fillOpacity"
                >
                </geom-icon>
            </li>
        </ul>
    </custom-scroll>
</section>
<header
    *checkVisibility="{
        visibleModes: [MapWorkspacePermissionType.FULL_ACCESS],
        visibleOnlyFor: [WorkspaceType.GIS]
    }"
>
    <gsp-button
        iconClass="icon_solid_menu i32"
        [type]="ButtonType.Icon"
        (action)="bulkActionsMenu.onContextMenu($event)"
    ></gsp-button>

    <gsp-context-menu #bulkActionsMenu [items]="contextMenuItems"> </gsp-context-menu>
</header>
